import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-357bf404")

_pushScopeId("data-v-357bf404")
const _hoisted_1 = { class: "modals table" }
const _hoisted_2 = { class: "middle tCell" }
const _hoisted_3 = {
  class: "blockMod paymentModal paymentForm",
  id: "paymentModal",
  ref: "el"
}
const _hoisted_4 = { class: "headBlock" }
const _hoisted_5 = {
  class: "formTitle",
  style: {"font-size":"18px"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "siteLogo2" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "logo"
  }),
  /*#__PURE__*/_createVNode("div", { class: "data" }, [
    /*#__PURE__*/_createVNode("span", { class: "subtitle" }, "powered by "),
    /*#__PURE__*/_createVNode("span", { class: "title" }, "money space")
  ])
], -1)
const _hoisted_7 = { class: "formBlock" }
const _hoisted_8 = { class: "fieldsWrap" }
const _hoisted_9 = { class: "fieldItem" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "inBlockType1" }
const _hoisted_12 = { for: "cardNumber" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "inWrap" }, [
  /*#__PURE__*/_createVNode("input", {
    type: "text",
    class: "cardNumber",
    name: "cardNumber",
    id: "cardNumber",
    value: "1123   2000   3200   2391"
  })
], -1)
const _hoisted_14 = { class: "fieldItem" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "inBlockType1" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "inWrap comb" }, [
  /*#__PURE__*/_createVNode("input", {
    type: "text",
    class: "cardMonth",
    name: "month",
    id: "month",
    value: "08"
  }),
  /*#__PURE__*/_createVNode("input", {
    type: "text",
    class: "cardYear",
    name: "year",
    id: "year",
    value: "2020"
  })
], -1)
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "inBlockType1" }
const _hoisted_20 = { for: "cvc" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "inWrap" }, [
  /*#__PURE__*/_createVNode("input", {
    type: "text",
    class: "cardCvc",
    name: "cvc",
    id: "cvc",
    value: "032"
  })
], -1)
const _hoisted_22 = { class: "btnFillType2 full upp" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "overlayModal" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: _ctx.state.Modal
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.t("startSection.createLinkPayForm.checkout")), 1),
            _hoisted_6
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("label", _hoisted_12, _toDisplayString(_ctx.t("startSection.createLinkPayForm.cardNoLabel")), 1),
                    _hoisted_13
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("label", null, _toDisplayString(_ctx.t("startSection.createLinkPayForm.expDateLabel")), 1),
                    _hoisted_17
                  ])
                ]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", _hoisted_19, [
                    _createVNode("label", _hoisted_20, _toDisplayString(_ctx.t("startSection.createLinkPayForm.cvcLabel")), 1),
                    _hoisted_21
                  ])
                ])
              ])
            ]),
            _createVNode("button", _hoisted_22, _toDisplayString(_ctx.t("startSection.createLinkPayForm.submit")), 1)
          ])
        ], 512),
        _hoisted_23
      ])
    ])
  ], 2))
})